import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAppSelector } from "@/store/hooks";

const AuthOnlyRoute = () => {
  const location = useLocation();

  const { user, isLoading } = useAppSelector((state) => state.auth);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default AuthOnlyRoute;
